export default class EventsService {
    /* @ngInject */
    constructor($q, AxiosService, AuthService) {
        this.$q = $q;
        this.AxiosService = AxiosService;
        this.AuthService = AuthService;
    }

    /**
     * Retrieves a list of events for a given thing
     *
     * @param {object} params - The parameters used to query for events
     * @param {Date} params.sortOrder - Optional sortorder. Default 'desc'
     * @param {Date} params.fromDate - The date to start the selection with
     * @param {Date} params.endDate - The date to end the selection with
     * @param {String} params.thingId - The ID of the thing to include events for
     */
    getEvents(params) {
        return this.$q((resolve, reject) => {
            const query = {
                size: 500,
                sort: [{ timestamp: params.sortOrder || 'desc' }],
                query: {
                    bool: {
                        must: [
                            {
                                range: {
                                    timestamp: {
                                        gte: params.fromDate.valueOf(),
                                        lte: params.toDate.valueOf(),
                                    },
                                },
                            },
                            {
                                term: { 'source.thingName': params.thingId },
                            },
                            {
                                term: {
                                    classification: 'ALARM',
                                },
                            },
                        ],
                    },
                },
            };

            this.AxiosService.http
                .post(
                    'events/find',
                    { query },
                    { headers: { authorization: this.AuthService.getToken() } },
                )
                .then(response => response.data)
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    /**
     * Retrieves a list of events for a given domain
     *
     * @param {object} params - The parameters used to query for events
     * @param {Date} params.fromDate - The date to start the selection with
     * @param {Date} params.endDate - The date to end the selection with
     * @param {String} [params.domainId] - The ID of the domain to include events for
     */
    getEventsForDomain(params) {
        return this.$q((resolve, reject) => {
            const query = {
                size: 500,
                sort: [
                    {
                        timestamp: 'desc',
                    },
                ],
                query: {
                    bool: {
                        must: [
                            {
                                range: {
                                    timestamp: {
                                        gte: params.fromDate.valueOf(),
                                        lte: params.toDate.valueOf(),
                                    },
                                },
                            },
                            {
                                term: {
                                    classification: 'ALARM',
                                },
                            },
                        ],
                    },
                },
            };
            // The domain id is optional, if no given all events for the logged
            // in user will be returned.
            if (params.domainId) {
                query.query.bool.must.push({
                    term: {
                        'source.domain': params.domainId,
                    },
                });
            }

            this.AxiosService.http
                .post(
                    'events/find',
                    { query },
                    { headers: { authorization: this.AuthService.getToken() } },
                )
                .then(response => response.data)
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    getEventsToAcknowledge(params) {
        return this.$q((resolve, reject) => {
            const query = {
                size: 500,
                sort: {
                    timestamp: {
                        order: 'desc',
                    },
                },
                query: {
                    bool: {
                        must: [
                            {
                                range: {
                                    timestamp: {
                                        gte: params.fromDate.valueOf(),
                                        lte: params.toDate.valueOf(),
                                    },
                                },
                            },
                            {
                                term: {
                                    acknowledgmentRequired: true,
                                },
                            },
                        ],
                        must_not: [
                            {
                                exists: {
                                    field: 'acknowledgedBy',
                                },
                            },
                        ],
                    },
                },
            };
            // The thingId is optional, if not given all unacknowledged alarms is returned
            if (params.thingId) {
                query.query.bool.must.push({
                    term: {
                        'source.thingName': params.thingId,
                    },
                });
            }

            return this.AxiosService.http
                .post(
                    'events/find',
                    { query },
                    { headers: { authorization: this.AuthService.getToken() } },
                )
                .then(response => response.data)
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }

    acknowledgeEvent(event) {
        return this.$q((resolve, reject) => {
            const eventId = event._source.id;

            return this.AxiosService.http
                .post(
                    `events/${eventId}/acknowledge`,
                    {},
                {
                    headers: { authorization: this.AuthService.getToken() },
                    params: { id: eventId },
                },
                )
                .then(response => response.data)
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/events.service.js